import asArray from 'utils/arrays/asArray.util';
import fromAnyToLowerCase from 'utils/converters/any/fromAnyToLowerCase.util';
import asObject from 'utils/objects/asObject.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

const sortOutstandingDeposits = (array) =>
  isFullArray(array)
    ? array.sort((a, b) => {
        const aa = fromAnyToLowerCase(asObject(a).clientName);
        const bb = fromAnyToLowerCase(asObject(b).clientName);
        return aa === bb ? 0 : aa > bb ? 1 : -1;
      })
    : asArray();

export default sortOutstandingDeposits;
